export default "__VITE_ASSET__lK814bKU__"